import classNames from "classnames";
import React, { type ReactNode } from "react";
import { useBootstrapPrefix } from "react-bootstrap/esm/ThemeProvider";
import type { BsPrefixProps, BsPrefixRefForwardingComponent } from "react-bootstrap/esm/helpers";
import { useBootstrapBreakpoints, useBootstrapMinBreakpoint } from "./ThemeProvider";
import type { ResponsiveUtilityValue } from "./createUtilityClasses";
import createUtilityClassName from "./createUtilityClasses";
import type { Direction } from "./types";

export interface IconBoxProps extends BsPrefixProps, React.HTMLAttributes<HTMLElement> {
	icon: ReactNode;
	direction?: ResponsiveUtilityValue<Direction>;
}

export const IconBox: BsPrefixRefForwardingComponent<"div", IconBoxProps> = React.forwardRef<HTMLElement, IconBoxProps>(
	(
		{
			as: Component = "div",
			bsPrefix,
			className,
			icon,
			direction: layout = {
				xs: "vertical",
				lg: "horizontal",
			},
			children,
			...props
		},
		ref,
	) => {
		bsPrefix = useBootstrapPrefix(bsPrefix, "ui3-icon-box");
		const breakpoints = useBootstrapBreakpoints();
		const minBreakpoint = useBootstrapMinBreakpoint();

		return (
			<Component
				ref={ref}
				className={classNames(
					className,
					bsPrefix,
					...createUtilityClassName(
						{
							[bsPrefix]: layout,
						},
						breakpoints,
						minBreakpoint,
					),
				)}
				{...props}
			>
				<div className={`${bsPrefix}-icon svg-inline--fa fa-fw`}>{icon}</div>
				<div className={`${bsPrefix}-content`}>{children}</div>
			</Component>
		);
	},
);
